import CancelledBookings from '@commons/bookings/cancelled'
import React from 'react'

const ProviderCancelledBookings = ({ user }) => {
  return <CancelledBookings user={user} />
}

export default ProviderCancelledBookings
